import request from '@/libs/request';
import config from '@/config';
const baseUrl = config.api_base;

/**
 * 查询附件类型
 * @param {*} params
 * @returns
 */
export const getAttachmentTypes = params => {
  return request('get', `${baseUrl}/api/auth/sys/attach/typs`, params);
};

/**
 * 查询附件树目录
 * @param {*} params
 * @returns
 */
export const getAttachmentTree = params => {
  return request('get', `${baseUrl}/api/auth/sys/attach/tree`, params);
};

/**
 * 搜索文件和文件夹
 * @param {*} params
 * @returns
 */
export const searchFilesAndFolders = params => {
  return request('get', `${baseUrl}/api/auth/sys/attach/search`, params);
};

/**
 * 新增目录
 * @param {*} data
 * @returns
 */
export const addDirectory = data => {
  return request('post', `${baseUrl}/api/auth/sys/attach/dir/add`, data);
};

/**
 * 删除指定目录（级联删除）
 * @param {*} data
 * @returns
 */
export const deleteDirectoryCascade = data => {
  return request('post', `${baseUrl}/api/auth/sys/attach/dir/ddel`, data);
};

/**
 * 删除指定目录（非级联删除）
 * @param {*} data
 * @returns
 */
export const deleteDirectoryNonCascade = data => {
  return request('post', `${baseUrl}/api/auth/sys/attach/dir/del`, data);
};

/**
 * 编辑目录
 * @param {*} data
 * @returns
 */
export const editDirectory = data => {
  return request('post', `${baseUrl}/api/auth/sys/attach/dir/edit`, data);
};

/**
 * 重命名附件目录
 * @param {*} data
 * @returns
 */
export const renameDirectory = data => {
  return request('post', `${baseUrl}/api/auth/sys/attach/dir/rename`, data);
};

/**
 * 上传多附件列表
 * @param {*} data
 * @returns
 */
export const uploadMultipleAttachments = data => {
  return request('post', `${baseUrl}/api/auth/sys/attach/dir/upload`, data);
};

/**
 * 编辑附件
 * @param {*} data
 * @returns
 */
export const editAttachment = data => {
  return request('post', `${baseUrl}/api/auth/sys/attach/file/edit`, data);
};

/**
 * 删除附件文件
 * @param {*} data
 * @returns
 */
export const deleteAttachmentFile = data => {
  return request('post', `${baseUrl}/api/auth/sys/attach/file/del`, data);
};

/**
 * 产生/重置附件分享地址
 * @param {*} data
 * @returns
 */
export const generateOrResetShareLink = data => {
  return request('post', `${baseUrl}/api/auth/sys/attach/share/new`, data);
};

/**
 * 获取附件分享信息
 * @param {*} params
 * @returns
 */
export const getShareInfo = params => {
  return request('get', `${baseUrl}/api/auth/sys/attach/share/get`, params);
};

/**
 * 文档分享（无需登录）
 * @param {*} params
 * @returns
 */
export const shareDocument = params => {
  return request('get', `${baseUrl}/api/unauth/share/attachment`, params);
};

/**
 * 获取附件分享信息
 * @param {*} params
 * @returns
 */
export const sharedInfo = params => {
  return request('get', `${baseUrl}/api/auth/sys/attach/share/get`, params);
};

/**
 * 销毁分享
 * @param {*} data
 * @returns
 */
export const destoryShared = data => {
  return request(
    'post',
    `${baseUrl}/api/auth/sys/attach/share/destory
`,
    data
  );
};
